module.exports = __webpack_public_path__ + "static/pic_padTeacher-9285e758c9cf8baba626349945eed477.png";